import { useState } from "react";
import {
  Box,
  Card,
  makeStyles,
  Typography,
  Chip,
  Button,
} from "@material-ui/core";
import { lighten } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CreateIcon from "@material-ui/icons/Create";
import SaveIcon from "@material-ui/icons/Save";

import BusinessCenterOutlinedIcon from "@material-ui/icons/BusinessCenterOutlined";
import SubjectPropertyView from "./subjectPropertyView";
import SubjectPropertyForm from "./subjectPropertyForm";
import { useStore } from "@roc/client-portal-shared/hooks";
import { segmentAnalytics, SegmentTrackerEventCompTool } from "@roc/feature-utils";
import { observer } from "mobx-react";
import PropertyViewModal from "./propertyViewModal";

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: lighten(theme.palette.primary.main, 0.95),
    borderRadius: "14px",
    padding: "2rem",
    width: "100%"
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "100%",
    width: "3rem",
    height: "3rem",
  },
  statusChip: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #2E7D32",
    color: "#2E7D32",
  },
  button: {
    paddingBlock: "0px !important",
    height: "40px",
    backgroundColor: "#FFFFFF"
  },
  icon: {
    fill: theme.palette.primary.main,
  },
}));

const SubjectPropertyCard = observer(() => {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const { compToolStoreV2: compToolStore } = useStore();

  const { subjectProperty, userStore, isInternal, internalUsername, editSubjectPropertyFormStore } = compToolStore;

  const viewClickHandler = () => {
    setOpenViewModal(true);
    segmentAnalytics.trackEvent({
      name: SegmentTrackerEventCompTool.COMP_TOOL_SUBJECT_PROPERTY_CLICKED,
      userName: isInternal ? internalUsername : userStore.userInformation?.username,
      subjectAddress: subjectProperty.data.address,
    });
  }

  const editClickHandler = () => {
    let property: any = { ...subjectProperty.data };
    if (subjectProperty?.data?.address) {
      const parts = subjectProperty.data.address.split(',').map(part => part.trim());
      const [address, city, state, zipCode] = parts;
      property = { ...property, address, city, state, zipCode };
    }

    setEditMode((prevValue) => !prevValue);
    compToolStore.setSelectedProperty(subjectProperty);
    editSubjectPropertyFormStore.loadForm(property);
    segmentAnalytics.trackEvent({
      name: SegmentTrackerEventCompTool.COMP_TOOL_SUBJECT_PROPERTY_CLICKED,
      userName: isInternal ? internalUsername : userStore.userInformation?.username,
      subjectAddress: subjectProperty.data.address,
    });
  };

  const saveClickHandler = () => {
    setEditMode((prevValue) => !prevValue);
    compToolStore.editSubjectProperty();
  }

  return (
    <Card className={classes.card}>
      <Box display="flex" flexDirection="column" gridGap="1rem">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gridGap="1rem">
            <Card className={classes.iconBox}>
              <BusinessCenterOutlinedIcon className={classes.icon} />
            </Card>
            <Typography variant="h4" style={{ marginLeft: "1rem" }}>
              Subject Property Information
            </Typography>
            {/* <Chip label="Active" className={classes.statusChip} /> */}
          </Box>
          <Box display="flex" gridGap="1rem">
            {editMode && (
              <Button
                className={classes.button}
                startIcon={<SaveIcon />}
                variant="outlined"
                color="primary"
                onClick={saveClickHandler}
              >
                Save
              </Button>
            )}
            {!editMode && (
              <>
                <Button
                  className={classes.button}
                  startIcon={<VisibilityIcon />}
                  variant="outlined"
                  color="primary"
                  onClick={viewClickHandler}
                >
                  Detail
                </Button>
                <Button
                  className={classes.button}
                  startIcon={<CreateIcon />}
                  variant="outlined"
                  color="primary"
                  onClick={editClickHandler}
                >
                  Edit
                </Button>
              </>
            )}
          </Box>
        </Box>
        {editMode ? (
          <SubjectPropertyForm />
        ) : (
          <SubjectPropertyView />
        )}
      </Box>
      <PropertyViewModal open={openViewModal} property={subjectProperty} onClose={() => setOpenViewModal(false)} />
    </Card>
  );
});

export default SubjectPropertyCard;
